module.exports = __webpack_public_path__ + "img/table-count-icon.98af39aa.png";